import axios from 'axios';
import Log from '../../utils/Debug';

import media from '../../../API_MOCKS/v3/media/index.json';

const API_URL = process.env.API_URL; // eslint-disable-line

export default (bottle) => {
  bottle.constant('mediaBrowserServicesURI', `${API_URL}/media`);

  bottle.factory(
    'mediaBrowserFetchMediaList',
    ({
      mediaBrowserServicesURI,
    }) => (token, testUrl, headers) => {
      const options = headers || {
        headers: {
          authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          'cache-control': 'no-cache',
        },
      };
      const url = testUrl || mediaBrowserServicesURI;
      return axios.get(url, options);
    },
  );

  bottle.factory(
    'mediaBrowserFetchMediaItem',
    ({
      mediaBrowserServicesURI,
    }) => (token, mediaId, testUrl) => {
      if (!token) {
        Log.error(token, '!!!! mediaBrowserFetchMediaItem Missing Token');
      }
      if (!mediaId) {
        Log.error(mediaId, '!!!! need a mediaId');
      }
      const options = {
        headers: {
          authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          'cache-control': 'no-cache',
        },
      };
      const url = testUrl || mediaBrowserServicesURI;
      return axios.get(`${url}/${mediaId}`, options);
    },
  );
};
